/**
 * PrivateRoute component
 * Redirects unauthenticated users to login page
 * Optionally requires admin privileges
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ 
  children, 
  adminOnly = false 
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    // Show loading spinner while checking auth status
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin required but user is not admin
  if (adminOnly && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated (and admin if required)
  return <>{children}</>;
};

export default PrivateRoute;
